import { useEffect, useRef, useState } from 'react';
import LayeredDashboardHeader from '../../LayeredDashboardHeader';
import useCustomNavigate from '../../../components/operational/goBack';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import CreateAction from '../../../components/operational/createAction';
import { useNavigate } from 'react-router-dom';
import Plans from '../Plans';
import Stepper from '../../../components/ui/Stepper/Stepper';
import BillingMain from '../Payment/BillingMain';
import Payment from '../Payment/Payment';
import AppDetails from './AppDetails';
import Links from './Links';
import Images from './Images';
import Request from './Request';
import Facebook from './Facebook';
import Upload from './Upload';
import Store from './Store';
import { UploadImageAsFormData } from '../../../components/operational/UploadImageAsFormData';
import { blobUrlToBlobConverter } from '../../../helper/Converters';
import { getLocalPublishData } from '../../../helper/Helpers';
import { JSONValidator } from '../../../helper/Validators';

const Publish = ({ tab, setIsActive }) => {
  const [activeStep, setActiveStep] = useState({ index: 0, direction: 'right' });
  const [data, setData] = useState({});
  const appDetailsFormButtonRef = useRef();
  const linksFormButtonRef = useRef();
  const imagesFormButtonRef = useRef();
  const facebookFormData = useRef();
  const storeFormButton = useRef();

  const setLocalPublishData = data => {
    const localPublishData = localStorage.getItem('localPublishData');

    const jsonLocalPublishData = JSONValidator(localPublishData);
    const storeId = localStorage.getItem('activeStoreId');

    const newLocalPublishData = { ...jsonLocalPublishData, [storeId]: data || {} };
    localStorage.setItem('localPublishData', JSON.stringify(newLocalPublishData));
  };
  const appDetailsSubmit = () => {
    appDetailsFormButtonRef?.current?.click();
  };
  const linksSubmit = () => {
    linksFormButtonRef?.current?.click();
  };
  const imagesSubmit = () => {
    imagesFormButtonRef?.current?.click();
  };
  const facebookSubmit = () => {
    facebookFormData?.current?.click();
  };
  const storeSubmit = () => {
    storeFormButton?.current?.click();
  };
  const nextPage = () => {
    setActiveStep(state => ({ index: state.index + 1, direction: 'right' }));
  };

  useEffect(() => {
    if (activeStep.index > 0) {
      setLocalPublishData(data);
    }
  }, [data]);

  const uploadPublishData = async data => {
    const uploadData = await uploadBlobImages(data);
    const response = await CreateAction({
      method: 'post',
      path: `/publishRequest`,
      showPreLoader: true,
      isFileUploading: false,
      data: { data: uploadData },
    });
    if (response.error) return;
    setLocalPublishData({});

    window.location.href = '/dashboard/publish';
  };

  const steps = [
    {
      name: 'Uygulama Bilgileri',
      backgroundStyle: 'bg-white',
      component: (
        <AppDetails onSave={nextPage} data={data} setData={setData} appDetailsFormButtonRef={appDetailsFormButtonRef} />
      ),
      button: { name: 'Kaydet ve Devam Et', callback: appDetailsSubmit },
    },

    // {
    //   name: 'Linkler',
    //   backgroundStyle: 'bg-white',
    //   component: <Links onSave={nextPage} data={data} setData={setData} linksFormButtonRef={linksFormButtonRef} />,
    //   button: { name: 'Kaydet ve Devam Et', callback: linksSubmit },
    // },
    // {
    //   name: 'Facebook',
    //   backgroundStyle: 'bg-white',
    //   component: <Facebook onSave={nextPage} data={data} setData={setData} facebookFormData={facebookFormData} />,
    //   button: { name: 'Kaydet ve Devam Et', callback: facebookSubmit },
    // },
    {
      name: 'Görseller',
      backgroundStyle: 'bg-white',
      component: <Images onSave={nextPage} data={data} setData={setData} imagesFormButtonRef={imagesFormButtonRef} />,
      button: { name: 'Kaydet ve Devam Et', callback: imagesSubmit },
    },
    {
      name: 'Yayınla',
      backgroundStyle: 'bg-white',
      component: <Store onSave={uploadPublishData} data={data} setData={setData} storeFormButton={storeFormButton} />,
      button: { name: 'Yayınla', callback: storeSubmit },
    },
  ];

  useEffect(() => {
    const localPublishData = getLocalPublishData();
    console.log(localPublishData);
    if (localPublishData) setData(localPublishData);
  }, []);
  return (
    <>
      <LayeredDashboardHeader
        setIsActive={setIsActive}
        onLeave={() => {
          setIsActive(false);
        }}
        tab={tab}
      ></LayeredDashboardHeader>

      <div className="w-full h-[calc(100dvh-60px)] overflow-auto scrollbar-y-visible bg-white">
        <div>
          <div className="p-[20px] flex items-center justify-center 2xl:p-[40px] flex-col max-w-[1270px] mx-auto gap-[20px]">
            <Stepper activeStep={activeStep} setActiveStep={setActiveStep} steps={steps} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Publish;

const uploadBlobImages = async data => {
  const images = data.images;
  const keys = Object.keys(images);
  const finalPublishData = { ...data };
  let error = true;
  for (const key of keys) {
    if (images[key]?.includes('blob')) {
      const file = await blobUrlToBlobConverter(images[key]);
      const fileData = new File([file], key + '.png', {
        type: 'image/png',
      });
      const uploadedImage = await UploadImageAsFormData(fileData, true);
      if (!uploadedImage?.result?.resultData?.url) delete finalPublishData[key];
      finalPublishData.images[key] = uploadedImage?.result?.resultData?.url;
    } else if (key === 'storePreviewImages') {
      for (const [index, previewImage] of images[key].entries()) {
        const file = await blobUrlToBlobConverter(previewImage);
        const fileData = new File([file], key + '.png', {
          type: 'image/png',
        });
        const uploadedImage = await UploadImageAsFormData(fileData, true);
        if (!uploadedImage?.result?.resultData?.url) delete finalPublishData[key];
        finalPublishData.images[key][index] = uploadedImage?.result?.resultData?.url;
      }
    } else {
      finalPublishData.images[key] = images[key];
    }
  }
  return finalPublishData;
};
